// src/components/Testimonials.jsx
import React from 'react';
import styles from '../styles/Testimonials.module.css';

const testimonials = [
  {
    name: 'Aarav Sharma',
    role: 'Investor',
    quote: 'StockKhata has transformed how I manage my investments. It’s simple, intuitive, and keeps everything in one place!',
    rating: 5,
  },
  {
    name: 'Priya Patel',
    role: 'Trader',
    quote: 'I love the clean design and ease of tracking my portfolio. No clutter, just what I need to stay on top of my game.',
    rating: 4,
  },
  {
    name: 'Rohan Gupta',
    role: 'Beginner Investor',
    quote: 'As a newbie, StockKhata made it easy to understand my investments without overwhelming me. Highly recommend!',
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section className={styles.testimonialsSection}>
      <h2 className={styles.sectionTitle}>What Our Users Say</h2>
      <div className={styles.testimonialsGrid}>
        {testimonials.map((testimonial, index) => (
          <div key={index} className={styles.testimonialCard}>
            <div className={styles.quoteWrapper}>
              <p className={styles.quote}>"{testimonial.quote}"</p>
            </div>
            <div className={styles.userInfo}>
              <h3 className={styles.userName}>{testimonial.name}</h3>
              <p className={styles.userRole}>{testimonial.role}</p>
              <div className={styles.rating}>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className={styles.star}>★</span>
                ))}
                {[...Array(5 - testimonial.rating)].map((_, i) => (
                  <span key={i} className={styles.emptyStar}>☆</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;